// AUTO-GENERATED by tools/generate-parallel.mjs --world 16. Do not edit by hand.
// Regenerate with: node tools/generate-parallel.mjs --world 16
// W16 (Riven) — board-geometry world. Holes carve the playable region
// // into Rings, Corridors, and Crescents. d=3-7 band; engine unchanged.
import type { LevelDef } from '@tessera/engine';

export const WORLD_16_GENERATED: LevelDef[] = [
  // d*=3  branching=7.11  D=0.010  tiles=9
  {
    id: 'w16-l01',
    world: 16,
    index: 1,
    radius: 4,
    holes: [{ q: -4, r: 2 }, { q: -4, r: 3 }, { q: -4, r: 4 }, { q: -3, r: 2 }, { q: -3, r: 3 }, { q: -3, r: 4 }, { q: -2, r: -2 }, { q: -2, r: 2 }, { q: -2, r: 3 }, { q: -2, r: 4 }, { q: -1, r: -3 }, { q: -1, r: -2 }, { q: -1, r: 2 }, { q: -1, r: 3 }, { q: -1, r: 4 }, { q: 0, r: -4 }, { q: 0, r: -3 }, { q: 0, r: -2 }, { q: 0, r: 2 }, { q: 0, r: 3 }, { q: 0, r: 4 }, { q: 1, r: -4 }, { q: 1, r: -3 }, { q: 1, r: -2 }, { q: 1, r: 2 }, { q: 1, r: 3 }, { q: 2, r: -4 }, { q: 2, r: -3 }, { q: 2, r: -2 }, { q: 2, r: 2 }, { q: 3, r: -4 }, { q: 3, r: -3 }, { q: 3, r: -2 }, { q: 4, r: -4 }, { q: 4, r: -3 }, { q: 4, r: -2 }],
    objective: { kind: 'clear', moveBudget: 5 },
    tiles: [
    { coord: { q: -4, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 4, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 4, r: -1 }, color: 0 },
    { coord: { q: 3, r: 1 }, color: 0 },
    { coord: { q: -3, r: -1 }, color: 1 },
    { coord: { q: -4, r: 1 }, color: 1 },
    { coord: { q: 2, r: 1 }, color: 2 },
    { coord: { q: 3, r: -1 }, color: 2 },
    ],
  },
  // d*=4  branching=8.65  D=0.103  tiles=9
  {
    id: 'w16-l02',
    world: 16,
    index: 2,
    radius: 3,
    holes: [{ q: -3, r: 0 }, { q: -3, r: 1 }, { q: -3, r: 2 }, { q: -2, r: -1 }, { q: -2, r: 0 }, { q: -2, r: 1 }, { q: -1, r: -2 }, { q: -1, r: -1 }, { q: -1, r: 0 }, { q: 0, r: -3 }, { q: 0, r: -2 }, { q: 0, r: -1 }, { q: 1, r: -3 }, { q: 1, r: -2 }, { q: 2, r: -3 }],
    objective: { kind: 'clear', moveBudget: 6 },
    tiles: [
    { coord: { q: -3, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: -2, r: 3 }, color: 1 },
    { coord: { q: -2, r: 2 }, color: 1 },
    { coord: { q: 2, r: -2 }, color: 2 },
    { coord: { q: 2, r: -1 }, color: 2 },
    ],
  },
  // d*=4  branching=9.78  D=0.107  tiles=9
  {
    id: 'w16-l03',
    world: 16,
    index: 3,
    radius: 3,
    holes: [{ q: -3, r: 0 }, { q: -3, r: 1 }, { q: -3, r: 2 }, { q: -2, r: -1 }, { q: -2, r: 0 }, { q: -2, r: 1 }, { q: -1, r: -2 }, { q: -1, r: -1 }, { q: -1, r: 0 }, { q: 0, r: -3 }, { q: 0, r: -2 }, { q: 0, r: -1 }, { q: 1, r: -3 }, { q: 1, r: -2 }, { q: 2, r: -3 }],
    objective: { kind: 'clear', moveBudget: 6 },
    tiles: [
    { coord: { q: -2, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 0 },
    { coord: { q: 2, r: -2 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: -2, r: 2 }, color: 2 },
    { coord: { q: -1, r: 2 }, color: 2 },
    ],
  },
  // d*=5  branching=9.67  D=0.194  tiles=9
  {
    id: 'w16-l04',
    world: 16,
    index: 4,
    radius: 3,
    holes: [{ q: -3, r: 0 }, { q: -3, r: 1 }, { q: -3, r: 2 }, { q: -2, r: -1 }, { q: -2, r: 0 }, { q: -2, r: 1 }, { q: -1, r: -2 }, { q: -1, r: -1 }, { q: -1, r: 0 }, { q: 0, r: -3 }, { q: 0, r: -2 }, { q: 0, r: -1 }, { q: 1, r: -3 }, { q: 1, r: -2 }, { q: 2, r: -3 }],
    objective: { kind: 'clear', moveBudget: 7 },
    tiles: [
    { coord: { q: 3, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: 2, r: -2 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 2 },
    { coord: { q: -2, r: 2 }, color: 2 },
    ],
  },
  // d*=5  branching=10.87  D=0.198  tiles=9
  {
    id: 'w16-l05',
    world: 16,
    index: 5,
    radius: 3,
    holes: [{ q: -3, r: 0 }, { q: -3, r: 1 }, { q: -3, r: 2 }, { q: -2, r: -1 }, { q: -2, r: 0 }, { q: -2, r: 1 }, { q: -1, r: -2 }, { q: -1, r: -1 }, { q: -1, r: 0 }, { q: 0, r: -3 }, { q: 0, r: -2 }, { q: 0, r: -1 }, { q: 1, r: -3 }, { q: 1, r: -2 }, { q: 2, r: -3 }],
    objective: { kind: 'clear', moveBudget: 7 },
    tiles: [
    { coord: { q: 3, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: -2, r: 2 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 1 },
    { coord: { q: 3, r: -1 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 2 },
    { coord: { q: -1, r: 3 }, color: 2 },
    ],
  },
  // d*=6  branching=9.87  D=0.282  tiles=9
  {
    id: 'w16-l06',
    world: 16,
    index: 6,
    radius: 3,
    holes: [{ q: -3, r: 0 }, { q: -3, r: 1 }, { q: -3, r: 2 }, { q: -2, r: -1 }, { q: -2, r: 0 }, { q: -2, r: 1 }, { q: -1, r: -2 }, { q: -1, r: -1 }, { q: -1, r: 0 }, { q: 0, r: -3 }, { q: 0, r: -2 }, { q: 0, r: -1 }, { q: 1, r: -3 }, { q: 1, r: -2 }, { q: 2, r: -3 }],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 0, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -2 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 0 },
    { coord: { q: -1, r: 3 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: -2, r: 2 }, color: 2 },
    { coord: { q: -2, r: 3 }, color: 2 },
    ],
  },
  // d*=6  branching=16.50  D=0.435  tiles=8
  {
    id: 'w16-l07',
    world: 16,
    index: 7,
    radius: 3,
    holes: [{ q: -1, r: 0 }, { q: -1, r: 1 }, { q: 0, r: -1 }, { q: 0, r: 0 }, { q: 0, r: 1 }, { q: 1, r: -1 }, { q: 1, r: 0 }],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: -3, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 0 },
    { coord: { q: 3, r: -1 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: -1, r: 3 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: -3, r: 2 }, color: 1 },
    ],
  },
  // d*=7  branching=15.52  D=0.453  tiles=11
  {
    id: 'w16-l08',
    world: 16,
    index: 8,
    radius: 4,
    holes: [{ q: -4, r: 0 }, { q: -4, r: 1 }, { q: -4, r: 2 }, { q: -4, r: 3 }, { q: -3, r: -1 }, { q: -3, r: 0 }, { q: -3, r: 1 }, { q: -3, r: 2 }, { q: -2, r: -2 }, { q: -2, r: -1 }, { q: -2, r: 0 }, { q: -2, r: 1 }, { q: -1, r: -3 }, { q: -1, r: -2 }, { q: -1, r: -1 }, { q: -1, r: 0 }, { q: 0, r: -4 }, { q: 0, r: -3 }, { q: 0, r: -2 }, { q: 0, r: -1 }, { q: 1, r: -4 }, { q: 1, r: -3 }, { q: 1, r: -2 }, { q: 2, r: -4 }, { q: 2, r: -3 }, { q: 3, r: -4 }],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: -3, r: 4 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 4, r: -4 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 4, r: -1 }, color: 0 },
    { coord: { q: 4, r: -3 }, color: 0 },
    { coord: { q: 4, r: -2 }, color: 0 },
    { coord: { q: 0, r: 4 }, color: 1 },
    { coord: { q: -1, r: 4 }, color: 1 },
    { coord: { q: -4, r: 4 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 2 },
    { coord: { q: 3, r: -3 }, color: 2 },
    ],
  },
  // d*=7  branching=16.33  D=0.454  tiles=11
  {
    id: 'w16-l09',
    world: 16,
    index: 9,
    radius: 4,
    holes: [{ q: -4, r: 0 }, { q: -4, r: 1 }, { q: -4, r: 2 }, { q: -4, r: 3 }, { q: -3, r: -1 }, { q: -3, r: 0 }, { q: -3, r: 1 }, { q: -3, r: 2 }, { q: -2, r: -2 }, { q: -2, r: -1 }, { q: -2, r: 0 }, { q: -2, r: 1 }, { q: -1, r: -3 }, { q: -1, r: -2 }, { q: -1, r: -1 }, { q: -1, r: 0 }, { q: 0, r: -4 }, { q: 0, r: -3 }, { q: 0, r: -2 }, { q: 0, r: -1 }, { q: 1, r: -4 }, { q: 1, r: -3 }, { q: 1, r: -2 }, { q: 2, r: -4 }, { q: 2, r: -3 }, { q: 3, r: -4 }],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: 4, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -4, r: 4 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 4 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: -2, r: 4 }, color: 0 },
    { coord: { q: 4, r: 0 }, color: 1 },
    { coord: { q: 4, r: -1 }, color: 1 },
    { coord: { q: 4, r: -4 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 2 },
    { coord: { q: -3, r: 4 }, color: 2 },
    ],
  },
  // d*=7  branching=14.20  D=0.532  tiles=8
  {
    id: 'w16-l10',
    world: 16,
    index: 10,
    radius: 3,
    holes: [{ q: -1, r: 0 }, { q: -1, r: 1 }, { q: 0, r: -1 }, { q: 0, r: 0 }, { q: 0, r: 1 }, { q: 1, r: -1 }, { q: 1, r: 0 }],
    objective: { kind: 'clear', moveBudget: 9 },
    tiles: [
    { coord: { q: -3, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: 2, r: -3 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: -1, r: 3 }, color: 1 },
    { coord: { q: 2, r: 1 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 1 },
    ],
  },
];
